/**
 * Step by step sidebar UI component
 * @param  data 
 * @returns 
 * data : Array
 * relatedLinks : array
 * relatedlink.url : string
 * relatedlink.text : rawHtml string
 * 
 */ 

 import React, { useState } from "react";
 import _ from "lodash"
 import {Link} from "gatsby"
 
function removeSlashes(URL){
    return URL.replace(/\//g,'');
}
function NextBackButtons(props) {
     if(!_.isNil(props.data)){
        let steps = [];    
        let allLinks = [];
        let activeLinks;
        let newLinks = [];
        //let stepTitle   = props.stepperInfo.stepperName;
        //let stepLink    = props.stepperInfo.stepperUri;
        let i = 1;
        let stepLinks = [];
        let currentStepPosts;
        props.data.forEach(StepByStep => {
            i++;
            //let activeLinks;
            currentStepPosts = StepByStep.posts.nodes;
            //console.log(currentStepPosts)
            for(const StepByStepPosts in currentStepPosts) {
                stepLinks.push(
                   currentStepPosts[StepByStepPosts].uri
                )
               // if(currentStepPosts[StepByStepPosts].uri.includes(props.currentURL)) {
               //     activeLinks = currentStepPosts[StepByStepPosts].uri
               // }
                if(removeSlashes(currentStepPosts[StepByStepPosts].uri) === removeSlashes(props.currentURL)){
                    activeLinks = currentStepPosts[StepByStepPosts].uri
                }
            }
        });
    let nextButton;
    let prevButton;
    let backToStart;
    console.log(stepLinks);

    if(props.currentURL !== props.stepperInfo.stepperUri) {
        stepLinks.map(function(value2, index, elements) {
            console.log('---');
            console.log(value2);
            console.log('---');
            console.log(activeLinks);
            console.log('---');
            if(value2 == activeLinks){
                console.log('====');
                console.log(value2);
                console.log('====');
                console.log(activeLinks);

                if(index === 0) {
                    backToStart = props.stepperInfo.stepperUri;
                    newLinks.push(
                        <li className="d-inline"><a href={'/'+backToStart} className="step-by-step-link button button--secondary--noicon prevpagelink">Previous</a></li>
                    )
                }

                if(elements[index-1] !== undefined) {
                    prevButton = elements[index-1]
                    newLinks.push(
                        <li className="d-inline"><a href={prevButton} className="step-by-step-link button button--secondary--noicon prevpagelink">Previous</a></li>
                    )
                    //console.log(prevButton)
                }
                if(elements[index+1] !== undefined) {
                    nextButton = elements[index+1]
                    newLinks.push(
                        <li className="d-inline"><a href={nextButton} className="step-by-step-link button button--secondary--noicon nextpagelink">Next</a></li>
                    )
                    //console.log(nextButton)
                }
            } 
    
            // do something
          });
    } else {
        // display a next button to the first entry
        newLinks.push(
            <li className="d-inline"><a href={stepLinks[0]} className="step-by-step-link button button--secondary--noicon nextpagelink">Next</a></li>
        )
    }

   
     
return (
    <ul className="step-next-back">
    {newLinks}
    </ul>
)
    } else {
        return null;
    }
}
export default NextBackButtons